<template>
  <div class="messenger" :style="{ height: height + 'px' }">

    <div class="left-column">
      <chat-groups
        :chat-groups="sortedChatGroups"
        :current-chat-group="currentChatGroup"
        :current-user-id="currentUserId"
        :chat-group-loaded="chatGroupLoaded"
        :chat-groups-reach-the-end="chatGroupsReachTheEnd">
      </chat-groups>
    </div>

    <div class="right-column">
      <chat-group-header
        :current-chat-group="currentChatGroup"
        :current-user-id="currentUserId"
        v-if="currentChatGroup"
        >
      </chat-group-header>

      <messages :messages="sortedMessages" :current-chat-group="currentChatGroup">
      </messages>
      <message-input :current-chat-group="currentChatGroup"></message-input>
    </div>

  </div>
</template>

<script>
import ChatGroups from './chat_groups.vue'
import Messages from './messages.vue'
import MessageInput from './message_input.vue'
import ChatGroupHeader from './chat_group_header.vue'

export default {
  props: ['currentUserId'],
  data() {
    return {
      chatGroups: [],
      messages: [],
      chatGroupsReachTheEnd: false,
      height: 0,
      currentChatGroupId: null,
      chatGroupLoaded: false
    };
  },
  components: {
    ChatGroups, Messages, MessageInput, ChatGroupHeader
  },
  created() {
    this.chatGroupChannel = this.subscribeChatGroupsChannel();
    this.messageChannel = this.subscribeMessageSubscription();
    if (this.$route.params.chat_group_id) { this.currentChatGroupId = this.$route.params.chat_group_id; }

    eventHub.$on('send-message', (chatGroup, newMessage) => {
      return this.messageChannel.speak(chatGroup.id, newMessage);
    });

    eventHub.$on('get-more-messages', (chatGroup, messageId) => {
      return this.messageChannel.getMessagesBefore(chatGroup.id, messageId, null);
    });

    return eventHub.$on('get-more-chat-groups', chatGroup => {
      return this.chatGroupChannel.getChatGroupsBefore(chatGroup.id, 30);
    });
  },

  watch: {
    '$route'() {
      return this.currentChatGroupId = this.$route.params.chat_group_id;
    },

    'currentChatGroupId'() {
      const chatGroup = this.findChatGroup(this.currentChatGroupId);

      if (chatGroup) {
        this.markAsReadForCurrentChatGroup();
        return this.messageChannel.getMessagesBefore(this.currentChatGroupId, null, null);
      }
    }
  },

  computed: {
    'currentChatGroup'() {
      if (!this.currentChatGroupId) { return; }
      return this.findChatGroup(this.currentChatGroupId);
    },
    'sortedChatGroups'() {
      return _.sortBy(this.chatGroups, 'updated_at').reverse();
    },
    'sortedMessages'() {
      const filteredMessages =  _.filter(this.messages, message=> {
        return message["chat_group_id"] === this.currentChatGroupId;
      });

      return _.sortBy(filteredMessages, 'created_at').reverse();
    }
  },

  mounted() {
    this.height = $(window).height() - $("main").offset().top;
    return $(window).on('resize', () => {
      return this.height = $(window).height() - $("main").offset().top;
    });
  },

  methods: {
    findChatGroup(chatGroupId){
      const chatGroupIndex = _.findIndex(this.chatGroups, chatGroup => chatGroupId === chatGroup.id);
      return this.chatGroups[chatGroupIndex];
    },

    markAsReadForCurrentChatGroup() {
      if (this.currentChatGroup.unread_count > 0) {
        this.messageChannel.markAsReadBefore(this.currentChatGroup.id, this.currentChatGroup.latest_message.id);
      }

      return this.currentChatGroup.unread_count = 0;
    },


    subscribeChatGroupsChannel() {
      return websocket.cable.subscriptions.create("ChatGroupsChannel", {
        connected: () => {
          if (this.currentChatGroupId) {
            this.chatGroupChannel.getChatGroup(this.currentChatGroupId);
            this.messageChannel.getMessagesBefore(this.currentChatGroupId, null, null);
          }
          return this.chatGroupChannel.getChatGroupsBefore(null, 30);
        },

        getChatGroup(chat_group_id){
          return this.perform("get_chat_group", {chat_group_id});
        },

        getChatGroupsBefore(chat_group_id, limit){
          return this.perform("get_chat_groups_before", {chat_group_id, limit});
        },

        received: response => {
          const { data } = response;

          if ((response.action === "get_chat_groups_before") && (data.length < 30)) {
            this.chatGroupsReachTheEnd = true;
          }

          _.each(data, newChatGroup => {
            const oldChatGroupIndex = _.findIndex(this.chatGroups, chatGroup => chatGroup.id === newChatGroup.id);

            if (oldChatGroupIndex >= 0) {
              this.chatGroups.splice(oldChatGroupIndex, 1);
            }

            newChatGroup.reachTheEnd = false;

            return this.chatGroups.push(newChatGroup);
          });

          return this.chatGroupLoaded = true;
        }
      }
      );
    },

    subscribeMessageSubscription() {
      return websocket.cable.subscriptions.create("MessagesChannel", {
        connected() {},

        received: response => {
          const { data } = response;
          let needMarkAsRead = false;
          const chatGroup = this.findChatGroup(response.chat_group_id);

          if (!chatGroup) {
            this.chatGroupChannel.getChatGroup(response.chat_group_id);
          }

          if (chatGroup && (response.action === "get_messages_before") && (response.data.length < 30)) {
            chatGroup.reachTheEnd = true;
          }

          _.each(data, newMessage => {
            const oldMessageIndex = _.findIndex(this.messages, message => message.id === newMessage.id);

            if (oldMessageIndex >= 0) {
              this.messages.splice(oldMessageIndex, 1);
            }
            this.messages.push(newMessage);

            if (chatGroup) {
              if (chatGroup !== this.currentChatGroup) {
                if ((!chatGroup.latest_message) || ((chatGroup.latest_message.created_at <= newMessage.created_at) && (chatGroup.latest_message.id !== newMessage.id))) {
                  chatGroup.unread_count = chatGroup.unread_count + 1;
                  chatGroup.latest_message = newMessage;
                  return chatGroup.updated_at = newMessage.created_at;
                }
              } else {
                if ((!chatGroup.latest_message) || ((chatGroup.latest_message.created_at <= newMessage.created_at) && (chatGroup.latest_message.id !== newMessage.id))) {
                  needMarkAsRead = true;
                  chatGroup.latest_message = newMessage;
                  return chatGroup.updated_at = newMessage.created_at;
                }
              }
            }
          });

          if (needMarkAsRead) {
            return this.messageChannel.markAsReadBefore(chatGroup.id, chatGroup.latest_message.id);
          }
        },

        speak(chat_group_id, content) {
          return this.perform('speak', {chat_group_id, local_id: this.generateUUID(), content});
        },

        markAsReadBefore(chat_group_id, message_id) {
          return this.perform('mark_as_read_before', {chat_group_id, message_id});
        },

        getMessagesBefore(chat_group_id, message_id, limit){
          return this.perform('get_messages_before', {chat_group_id, message_id, limit});
        },

        generateUUID() {
          let d = (new Date).getTime();
          const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = ((d + (Math.random() * 16)) % 16) | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
          });
          return uuid;
        }
      }
      );
    }
  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/messenger/messenger.vue